import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FiEdit, FiTrash2, FiPlus, FiArrowLeft, FiSave, FiX } from 'react-icons/fi';
import { database } from '../../Firebase';
import { ref, onValue, push, update, remove } from 'firebase/database';

const TaxType = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { grampanchayatName, arthikVarshLabel } = location.state || {};

  const [view, setView] = useState('table'); // 'table' or 'form'
  const [formData, setFormData] = useState({
    id: '', // Store Firebase key here
    systemType: 'झोपडी मातीचे घर',
    typeNo: '',
    typeName: '',
    minRate: '',
    maxRate: '',
    taxRate: ''
  });

  // Data from Firebase
  const [data, setData] = useState([]);

  // Fetch Data from Firebase
  useEffect(() => {
    const taxTypesRef = ref(database, 'Grampanchayat/Gramniddhi/karprakar');
    
    const unsubscribe = onValue(taxTypesRef, (snapshot) => {
      const fetchedData = [];
      snapshot.forEach((childSnapshot) => {
        fetchedData.push({
          id: childSnapshot.key,
          ...childSnapshot.val()
        });
      });
      setData(fetchedData);
    });

    return () => unsubscribe();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleEdit = (item) => {
    setFormData({
      id: item.id, // Important: Set the Firebase key
      systemType: item.systemType || item.name || '', // Fallback for stability
      typeNo: item.typeNo || item.id || '',
      typeName: item.typeName || item.name || '',
      minRate: item.minRate || item.min || '',
      maxRate: item.maxRate || item.max || '',
      taxRate: item.taxRate || item.rate || ''
    });
    setView('form');
  };

  const handleDelete = (id) => {
    if (window.confirm('तुम्ही नक्की हे रेकॉर्ड हटवू इच्छिता?')) {
      const recordRef = ref(database, `Grampanchayat/Gramniddhi/karprakar/${id}`);
      remove(recordRef)
        .then(() => {
          // Success handled by onValue
        })
        .catch((error) => {
          alert('हटवताना त्रुटी आली: ' + error.message);
        });
    }
  };

  const handleSave = () => {
    if (!formData.typeName || !formData.taxRate) {
        alert('कृपया प्रकाराचे नाव आणि कराचा दर भरा');
        return;
    }

    const recordData = {
        systemType: formData.systemType,
        typeNo: formData.typeNo,
        typeName: formData.typeName,
        minRate: formData.minRate,
        maxRate: formData.maxRate,
        taxRate: formData.taxRate,
        // You can add timestamp if needed
        updatedAt: new Date().toISOString()
    };

    if (formData.id) {
        // Update existing
        const recordRef = ref(database, `Grampanchayat/Gramniddhi/karprakar/${formData.id}`);
        update(recordRef, recordData)
            .then(() => {
                alert('माहिती यशस्वीरित्या अपडेट केली!');
                resetForm();
            })
            .catch((error) => {
                alert('अपडेट करताना त्रुटी आली: ' + error.message);
            });
    } else {
        // Add new
        const listRef = ref(database, 'Grampanchayat/Gramniddhi/karprakar');
        push(listRef, recordData)
            .then(() => {
                alert('माहिती यशस्वीरित्या जतन केली!');
                resetForm();
            })
            .catch((error) => {
                alert('जतन करताना त्रुटी आली: ' + error.message);
            });
    }
  };

  const resetForm = () => {
    setView('table');
    setFormData({
      id: '',
      systemType: 'झोपडी मातीचे घर',
      typeNo: '',
      typeName: '',
      minRate: '',
      maxRate: '',
      taxRate: ''
    });
  };

  return (
    <div className="min-h-screen bg-gray-50 p-4 md:p-8">
      {/* Header */}
      <div className="max-w-7xl mx-auto mb-6">
        <div className="bg-[#267c77] text-white rounded-t-lg shadow-lg p-4 flex justify-between items-center">
          <div className="flex items-center gap-4">
            <button 
              onClick={() => navigate('/asthapan/tax-system', { state: location.state })}
              className="p-1 rounded-full hover:bg-white/20 transition-colors"
            >
              <FiArrowLeft size={24} />
            </button>
            <h1 className="text-xl font-bold">
              {view === 'table' ? 'करांचे प्रकार व दर माहिती' : 'नविन कराचा प्रकार माहिती'}
            </h1>
          </div>
          <div className="flex gap-4">
             {view === 'table' && (
                <button 
                onClick={() => {
                    resetForm();
                    setView('form');
                }}
                className="bg-[#267c77] hover:bg-[#1e6b66] text-white px-4 py-1.5 rounded shadow transition-colors flex items-center gap-2 font-medium"
                >
                <FiPlus /> नविन
                </button>
             )}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto bg-white rounded-b-lg shadow-lg overflow-hidden border border-gray-200">
        
        {view === 'table' ? (
          /* Table View */
          <div className="p-0">
            <div className="overflow-x-auto">
              <table className="w-full text-sm text-left text-gray-700">
                <thead className="text-xs text-white uppercase bg-[#267c77]">
                  <tr>
                    <th className="px-6 py-3 border-r border-[#1e6b66] w-24 text-center">प्रकाराचा नं.</th>
                    <th className="px-6 py-3 border-r border-[#1e6b66]">प्रकाराचे नाव</th>
                    <th className="px-6 py-3 border-r border-[#1e6b66] text-right w-32">किमान</th>
                    <th className="px-6 py-3 border-r border-[#1e6b66] text-right w-32">कमाल</th>
                    <th className="px-6 py-3 border-r border-[#1e6b66] text-right w-32">कराचा दर</th>
                    <th className="px-6 py-3 text-center w-32">क्रिया</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                      data.map((item, index) => (
                        <tr key={item.id} className="border-b hover:bg-gray-50">
                          <td className="px-6 py-4 border-r text-center font-medium">{item.typeNo || index + 1}</td>
                          <td className="px-6 py-4 border-r font-medium text-gray-900">{item.typeName || item.name}</td>
                          <td className="px-6 py-4 border-r text-right">{item.minRate || item.min}</td>
                          <td className="px-6 py-4 border-r text-right">{item.maxRate || item.max}</td>
                          <td className="px-6 py-4 border-r text-right">{item.taxRate || item.rate}</td>
                          <td className="px-6 py-4 text-center flex justify-center gap-2">
                            <button 
                              onClick={() => handleEdit(item)}
                              className="bg-[#267c77] hover:bg-[#1e6b66] text-white px-3 py-1 rounded text-xs transition-colors shadow-sm"
                            >
                              <FiEdit />
                            </button>
                            <button 
                              onClick={() => handleDelete(item.id)}
                              className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded text-xs transition-colors shadow-sm"
                            >
                              <FiTrash2 />
                            </button>
                          </td>
                        </tr>
                      ))
                  ) : (
                      <tr>
                          <td colSpan="6" className="px-6 py-8 text-center text-gray-500">
                              माहिती उपलब्ध नाही. नवीन रेकॉर्ड जोडा.
                          </td>
                      </tr>
                  )}
                </tbody>
              </table>
            </div>

            {/* Footer Actions */}
            <div className="bg-[#267c77] p-4 flex justify-center sticky bottom-0">
               <button 
                  onClick={() => navigate('/asthapan/tax-system', { state: location.state })}
                  className="bg-red-600 hover:bg-red-700 text-white px-6 py-2 rounded shadow transition-colors font-bold"
                >
                  रद्द करणे
                </button>
            </div>
          </div>
        ) : (
          /* Form View */
          <div className="p-8">
            <div className="max-w-4xl mx-auto space-y-6">
              
              {/* System Type */}
              <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-center">
                <div className="md:col-span-3">
                  <label className="block text-gray-700 font-semibold mb-2 md:mb-0">
                    प्रणालीचा प्रकार
                  </label>
                </div>
                <div className="md:col-span-9">
                  <select
                    name="systemType"
                    value={formData.systemType}
                    onChange={handleInputChange}
                    className="w-full p-2.5 bg-white border border-gray-300 text-gray-900 text-sm rounded focus:ring-[#267c77] focus:border-[#267c77]"
                  >
                    <option value="">निवडा</option>
                    <option>झोपडी मातीचे घर</option>
                    <option>दगड विटा मातीची इमारत</option>
                    <option>दगड विट सिमेंट घर / लोड बेरांग</option>
                    <option>आर सी सी इमारत</option>
                    <option>बखळ जागा</option>
                    <option>सामान्य पाणीपट्टी</option>
                    <option>खास पाणीपट्टी</option>
                  </select>
                </div>
              </div>

              {/* Type No */}
              <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-center">
                <div className="md:col-span-3">
                  <label className="block text-gray-700 font-semibold mb-2 md:mb-0">
                    प्रकार नं.
                  </label>
                </div>
                <div className="md:col-span-9">
                  <input
                    type="text"
                    name="typeNo"
                    value={formData.typeNo}
                    onChange={handleInputChange}
                    placeholder="प्रकार नं. भरा"
                    className="w-full p-2.5 bg-white border border-gray-300 text-gray-900 text-sm rounded focus:ring-[#267c77] focus:border-[#267c77]"
                  />
                </div>
              </div>

              {/* Type Name */}
              <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-center">
                <div className="md:col-span-3">
                  <label className="block text-gray-700 font-semibold mb-2 md:mb-0">
                    प्रकाराचे नाव
                  </label>
                </div>
                <div className="md:col-span-9">
                  <input
                    type="text"
                    name="typeName"
                    value={formData.typeName}
                    onChange={handleInputChange}
                    placeholder="प्रकाराचे नाव भरा"
                    className="w-full p-2.5 bg-white border border-[#267c77] text-gray-900 text-sm rounded focus:ring-[#267c77] focus:border-[#267c77] outline-none"
                  />
                </div>
              </div>

              {/* Min Rate */}
              <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-center">
                <div className="md:col-span-3">
                  <label className="block text-gray-700 font-semibold mb-2 md:mb-0">
                    किमान दर
                  </label>
                </div>
                <div className="md:col-span-9">
                   <input
                    type="number"
                    name="minRate"
                    value={formData.minRate}
                    onChange={handleInputChange}
                    placeholder="किमान दर"
                    className="w-full p-2.5 bg-white border border-[#267c77] text-gray-900 text-sm rounded focus:ring-[#267c77] focus:border-[#267c77] outline-none"
                  />
                </div>
              </div>

              {/* Max Rate */}
              <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-center">
                <div className="md:col-span-3">
                  <label className="block text-gray-700 font-semibold mb-2 md:mb-0">
                    कमाल दर
                  </label>
                </div>
                <div className="md:col-span-9">
                   <input
                    type="number"
                    name="maxRate"
                    value={formData.maxRate}
                    onChange={handleInputChange}
                    placeholder="कमाल दर"
                    className="w-full p-2.5 bg-white border border-[#267c77] text-gray-900 text-sm rounded focus:ring-[#267c77] focus:border-[#267c77] outline-none"
                  />
                </div>
              </div>

               {/* Tax Rate */}
               <div className="grid grid-cols-1 md:grid-cols-12 gap-4 items-center">
                <div className="md:col-span-3">
                  <label className="block text-gray-700 font-semibold mb-2 md:mb-0">
                    कराचा दर
                  </label>
                </div>
                <div className="md:col-span-9">
                    <input
                    type="number"
                    name="taxRate"
                    value={formData.taxRate}
                    onChange={handleInputChange}
                    placeholder="कराचा दर"
                    className="w-full p-2.5 bg-white border border-[#267c77] text-gray-900 text-sm rounded focus:ring-[#267c77] focus:border-[#267c77] outline-none"
                  />
                </div>
              </div>

            </div>

             {/* Form Actions */}
             <div className="flex justify-center gap-4 mt-12 mb-4">
                 <button 
                  onClick={handleSave}
                  className="bg-[#267c77] hover:bg-[#1e6b66] text-white px-8 py-2.5 rounded shadow transition-colors font-bold flex items-center gap-2"
                >
                  <FiSave /> साठविणे
                </button>
                <button 
                  onClick={resetForm}
                  className="bg-red-600 hover:bg-red-700 text-white px-8 py-2.5 rounded shadow transition-colors font-bold flex items-center gap-2"
                >
                  <FiX /> रद्द करणे
                </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default TaxType;
